<script setup lang="ts">
import { LucideSparkles, LucideArrowRight, LucideCheckCircle } from 'lucide-vue-next'

const { t } = useI18n()

const props = withDefaults(defineProps<{
  title?: string
  text?: string
  organization?: string
}>(), {
  title: '',
  text: '',
  organization: 'microcredit_company'
})

const displayTitle = computed(() => props.title || t('common.best_microcredits_title'))
const displayText = computed(() => props.text || t('common.best_microcredits_text'))

const linkUrl = computed(() => `/credits?organization=${props.organization}`)
</script>
<template>
  <SidebarBlock variant="white" class="overflow-hidden !p-0">
    <div class="relative space-y-4 p-6">
      <div class="flex items-center gap-3 xl:items-start">
        <div
          class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-purple-600"
        >
          <LucideSparkles class="h-5 w-5 text-white" />
        </div>
        <div>
          <Heading tag="h2" class="h6">{{ displayTitle }}</Heading>
        </div>
      </div>

      <div class="flex items-start gap-2">
        <LucideCheckCircle class="mt-1 h-4 w-4 flex-shrink-0 text-green-500" />
        <p>{{ displayText }}</p>
      </div>

      <Button as-child class="w-full">
        <NuxtLinkLocale :to="linkUrl" class="flex items-center justify-center gap-2">
          <span class="font-semibold">{{ $t('common.best_microcredits_action') }}</span>
          <LucideArrowRight class="h-4 w-4" />
        </NuxtLinkLocale>
      </Button>
    </div>
  </SidebarBlock>
</template>
